import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import ProjectDetails from './components/ProjectDetails';
import ScrollToTop from './components/ScrollToTop';
import Contact from './pages/Contact';

const App = () => {
  useEffect(() => {
    const defaultColors = {
      primary: '#FFD700',//#f8aa13 //#FFD700
      secondary: '#114577',//#112c53 //#114577
      secondary2: '#9ecb34',
      text: '#E5E9EC',
    };

    fetch('/api/theme')
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((colors) => {
        const appliedColors = {
          primary: colors?.primary || defaultColors.primary,
          secondary: colors?.secondary || defaultColors.secondary,
          secondary: colors?.secondary2 || defaultColors.secondary2,
          text: colors?.text || defaultColors.text,
        };

        document.documentElement.style.setProperty('--primary-color', appliedColors.primary);
        document.documentElement.style.setProperty('--secondary-color', appliedColors.secondary);
        document.documentElement.style.setProperty('--secondary-color2', appliedColors.secondary2);
        document.documentElement.style.setProperty('--text-color', appliedColors.text);
      })
      .catch((err) => {
        console.error('Failed to fetch theme colors:', err);
        document.documentElement.style.setProperty('--primary-color', defaultColors.primary);
        document.documentElement.style.setProperty('--secondary-color', defaultColors.secondary);
        document.documentElement.style.setProperty('--secondary-color2', defaultColors.secondary2);
        document.documentElement.style.setProperty('--text-color', defaultColors.text);
      });
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <ScrollToTop />
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetails />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
